import { Volume2, VolumeX } from 'lucide-react';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface AvatarVideoOverlayProps {
  src: string;
  onEnded: () => void;
}

export function AvatarVideoOverlay({ src, onEnded }: AvatarVideoOverlayProps) {
  const { t } = useTranslation();
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMuted, setIsMuted] = useState(false);
  const [hasEnded, setHasEnded] = useState(false);

  const handleEnded = useCallback(() => {
    setHasEnded(true);
    onEnded();
  }, [onEnded]);

  const toggleMute = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(videoRef.current.muted);
    }
  }, []);

  if (hasEnded) return null;

  return (
    <div className='absolute inset-0 z-10 bg-black'>
      <video
        ref={videoRef}
        src={src}
        autoPlay
        playsInline
        onEnded={handleEnded}
        className='h-full w-full object-contain'
      />
      <button
        type='button'
        onClick={toggleMute}
        aria-label={isMuted ? t('video.recording.unmute') : t('video.recording.mute')}
        className='absolute bottom-3 right-3 p-2 rounded-full bg-black/60 text-white hover:bg-black/80 transition-colors'>
        {isMuted ? (
          <VolumeX className='h-4 w-4' aria-hidden='true' />
        ) : (
          <Volume2 className='h-4 w-4' aria-hidden='true' />
        )}
      </button>
    </div>
  );
}
